
import React from "react";
import { TextArea, ImageUpload, SelectField, RadioGroupField, TextField, CheckBox } from "../controllers/addDemandcontrollers";
import { ErrorMessage, useFormikContext } from "formik";
import { allocatedCapacityOptions, CATEGORY, selectionType } from "../demandHelper";
import { FormFieldLabel as Label, FormErrorLabel as ErrorLabel, } from "../../../../../components/label/Labels";
import styles from './demandForms.module.css'
import { FieldWrapper } from "../../../../../components/Section/Section";
import Asterisk from "../../../../../components/asterisk/Asterisk";

const HttpFields = React.memo(({ index }) => {
    const { values, setFieldValue } = useFormikContext();

    return (
        <>
            <Label text={"Select Category"} /><Asterisk/>
                <FieldWrapper>
                    <div className={styles.checkboxalign}>
                        <CheckBox
                            name={`info.${index}.category`}
                            value={CATEGORY.ON_NET.value}
                            label={CATEGORY.ON_NET.label}/>
                        <CheckBox
                            name={`info.${index}.category`}
                            value={CATEGORY.OFF_NET.value}
                            label={CATEGORY.OFF_NET.label}/>
                    </div>
                    <ErrorMessage name={`info.${index}.category`}>
                        {(msg) => <ErrorLabel text={msg} />}
                    </ErrorMessage>
                </FieldWrapper>
            <TextField
                label="Average Monthly Transaction Volumes (TTR)"
                name={`info.${index}.avg_mon_trans_volume`}
                type="text"
                placeholder="Average Monthly Transaction Volumes (TTR)"
            />
            <SelectField
                title={"Do you have a 5G Core?"}
                name={`info.${index}.fiveG_Core`}
                options={selectionType}
                onChange={(value) => ""}
                customStyles={{ width: "100%" }}
            />
             <SelectField
                title={"Have you launched 5G SA domestically?"}
                name={`info.${index}.fiveG_SA_domestically`}
                options={selectionType}
                onChange={(value) => ""}
                customStyles={{ width: "100%" }}
            />
             <SelectField
                title={"Do you require a hosted SePP at Vodafone?"}
                name={`info.${index}.hosted_Sepp_at_vodafone`}
                options={selectionType}
                onChange={(value) => ""}
                customStyles={{ width: "100%" }}
            />
            <div className="flex-item">
                <TextArea
                    label={"Additional Information"}
                    id="description"
                    name={`info.${index}.comment`}
                    placeholder="Optional notes..."
                    rows={3}
                    maxlength={`${values?.info?.[index]?.comment?.length}/1000 characters`}
                />
            </div>
            <ImageUpload
                label="Supporting Attachments"
                optional={false}
                name={`info.${index}.files`}
                value={values.info[index].files}
                setFieldValue={setFieldValue}
                displayMessage={"Upload limit: Up to 3 files, max 5 MB each."}
                maxFileSize={5 * 1024 * 1024}
                maxFileSizeTXT={"5MB"}
                combineFilesMaxSize={15 * 1024 * 1024}
                combineFilesMaxSizeTXT={"Combined file size exceeds the 15MB limit"}
                numOfFilesAllowToUpload={3}
                errorMessageForNumberOfFiles={"You can upload max 3 files."}
                acceptFileType={
                    {    
                    'image/*': ['.jpeg','.png',],
                    'application/pdf': ['.pdf'],
                    'application/vnd.ms-excel': ['.xls',],
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':['.xlsx'],
                    'application/msword':['.doc'],
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':['.docx']
                    }
                }
            />
        </>
    );
});

export default HttpFields;